import { render, staticRenderFns } from "./OfferModule.vue?vue&type=template&id=779b38f6&scoped=true&"
import script from "./OfferModule.vue?vue&type=script&lang=js&"
export * from "./OfferModule.vue?vue&type=script&lang=js&"
import style0 from "./OfferModule.vue?vue&type=style&index=0&id=779b38f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b38f6",
  null
  
)

component.options.__file = "OfferModule.vue"
export default component.exports